import React from 'react';
import BaseForm from '../../../../../components/form/BaseForm';
import Panel from '../../../../../components/outline/Panel';
import { RECOMMEND_SEARCH_WORD_TYPE_TEXT } from '../../../../../constants/service/app/recommendSearchWordConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { setDateFormat } from '../../../../../lib/moment';

const RecommendSearchWordDetailInfo = (props) => {
  const { recommendSearchWordInfo } = props;
  const { adminName, type, createDate, memo } = recommendSearchWordInfo;

  return (
    <Panel className="recommend-search-word-detail-info">
      <div className="panel-header">
        <div className="title">추천 검색 키워드 정보</div>
      </div>

      <div className="panel-body">
        {/* 추천인 */}
        <BaseForm label="추천인" content={adminName ? adminName : '스케줄러'} />

        {/* 추천 검색 키워드 타입 */}
        <BaseForm label="추천 검색 키워드 타입" content={RECOMMEND_SEARCH_WORD_TYPE_TEXT[type]} />

        {/* 추천 검색 키워드 생성일 */}
        <BaseForm label="추천 검색 키워드 생성일" content={setDateFormat(createDate, DATE_FORMAT.FULL_DASH_FORMAT)} />

        {/* 메모 */}
        <BaseForm label="메모" content={memo} />
      </div>
    </Panel>
  );
};

export default RecommendSearchWordDetailInfo;
